/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Logo_AltInputs */

const en_wc_logo_alt = /** @type {(inputs: Wc_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraftApp logo`)
};

/**
* | output |
* | --- |
* | "WordCraftApp logo" |
*
* @param {Wc_Logo_AltInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_logo_alt = /** @type {((inputs?: Wc_Logo_AltInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Logo_AltInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_logo_alt(inputs)
});
export { wc_logo_alt as "wc.logo_alt" }